export default "__VITE_ASSET__e377c44f__"